<template lang="pug">
  .contenedor-interno(v-on-clickaway="close")
    .title
      span Cargos
    .search
      .control
        input.input(
          type="text",
          placeholder="Buscar cargos...",
          v-model="filtro"
          @keyup.enter="selectFirst"
          @keyup.esc="close"
          ref="busqueda"
          @input="fetchSearch"
        )
    .data
      transition-group.contenedor-data(v-infinite-scroll="fetchByScroll" infinite-scroll-disabled="disabledScrollExcecute" infinite-scroll-distance="2" name="fade-smooth-two" tag="div")
        .usuario(
          v-for="(o, index) in filteredLista"
          :key="'cargo_lookup_'+index"
          @click="seleccionarClick(o)"
        )
            span.nombre &nbsp;{{ o.cargo }}
      .info-message(v-if="!isLoading & filteredLista.length === 0")
        span No se encontraron coincidencias
      .is-loading.text-center(v-if="isLoading")
        span.icon
          i.fa.fa-spin.fa-spinner

</template>

<script>
import { apiGet, notify } from '../util/general'
import _ from 'lodash'
import cargandoLoad   from './Component_Cargando'
export default {
  name: 'lookup_cargo',
  components : {
    'loading-global' : cargandoLoad
  },
  data () {
    return {
      empleados              : [],
      filteredLista      : [],
      filtro                 : '',
      isLoading              : false,
      isScroll               : false,
      disabledScrollExcecute : true,
      skip                   : 0,
      noMore                 : false
    }
  },
  created () {
    this.fetch()
  },
  mounted () {
    this.$refs.busqueda.focus()
  },
  methods: {
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    },
    fetchSearch : _.debounce(function (value) {
      var vm = this
      vm.fetch()
    }, 300),
    fetch () {
      var vm = this
      vm.isLoading                = true
      vm.disabledScrollExcecute   = true
      vm.noMore                   = false
      if (!vm.isScroll) {
        vm.filteredLista = []
        vm.skip = 0
      }
      var obj = {
        cargo: vm.filtro,
        skip : vm.skip
      }

      apiGet(vm, '/funciones_pdf/obtener', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.filteredLista.push(data.lista[i])
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExcecute = true
        } else {
          vm.skip += data.lista.length
          vm.disabledScrollExcecute = false
        }

        vm.isLoading         = false
        vm.isScroll = false
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.disabledScrollExcecute = true
        vm.isScroll = false
      })
    },
    selectFirst () {
      if (this.filteredLista.length === 0) {
        this.$emit('close')
      } else {
        this.$emit('selected', this.filteredLista[0])
        this.$emit('close')
      }
    },
    seleccionarClick (o) {
      this.$emit('selected', o)
      this.$emit('close')
    },
    close () {
      this.$emit('close', this.filteredLista[0])
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    display flex
    flex-direction column

    .title
      margin 10px 5px 5px 5px
      font-size 17px
      border-bottom 1px solid #ccc
      padding-bottom 10px
      text-align center

    .search
      padding 5px 10px

    .data
      max-height: 180px;
      overflow-y: auto;
      .contenedor-box
        >*
          transition all .5s
          width 100%
      padding 10px
      .usuario
        background: #fff;
        border-radius: 3px;
        border: 1px solid #d6dadc;
        border-bottom-color: #c4c9cc;
        -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
        box-shadow: 0 1px 6px rgba(0,0,0,.15);
        display flex
        padding 10px
        margin-bottom 5px
        cursor pointer
        transition all .2s ease

        &:hover
          background-color: #edeff0;
          margin-left: 4px;
          -webkit-box-shadow: -8px 0 #959da17d;
          box-shadow: -8px 0 #959da17d;

        .nombre
          flex 1
</style>



// WEBPACK FOOTER //
// Component_Lookup_Cargo.vue?3c3eb852